<!--
확대기능을 가진 이미지 컴포넌트
-------------------
- 이미지 사이즈는 inline style로 컴포넌트에 정의해서 조정가능
  <img-zoom style="width: 100px; height: 100px"></img-zoom>

- vue-photo-zoom-pro 2버전대 사용함(vue2용)
- https://mater1996.github.io/vue-photo-zoom-pro/guide/#image

-->
<template>
    <div class="container" style="width: 100px; height: 100px;">
        <a target="_blank" :href="src">
            <img class="lazyloaded thumbnail" :src="src"  :data-src="src" @mouseenter="previewOn" @mouseleave="previewOff" />
        </a>



        <!-- 화면 가운데 미리보기 -->
        <div class="preview" :class="previewClass" v-if="! disablePreview">
            <img class="lazyloaded" :src="src"/>
        </div>


        <!-- 오버레이 상세보기 -->
        <div class="overlay" :class="overlayClass" ref="overlay" @click="overlayOff">

            <div class="dialog-caption">
                CLICK TO CLOSE.
            </div>

            <div class="dialog">
                <vue-photo-zoom-pro ref="zoom" :url="src" :high-url="src" @update="listenCreatedPhotoZoomPro" style="cursor: crosshair; width: 100%; height: 100%;">
                </vue-photo-zoom-pro>
            </div>

        </div>


    </div>
</template>

<script>
import VuePhotoZoomPro from 'vue-photo-zoom-pro'
import 'vue-photo-zoom-pro/dist/style/vue-photo-zoom-pro.css'


export default {
    components: {
        VuePhotoZoomPro,
    },
    props: {
        /**
         * 이미지 url
         **/
        src: {
            type: String,
            default: null,
        },

        /**
         * 미리보기기능 사용안함
         **/
        disablePreview: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            // (bool) on/off 여부
            previewSwitch: false,
            // (bool) on/off 여부
            overlaySwitch: false,
        };
    },
    mounted() {
        this.initLightbox();
    },
    computed: {
        /**
         * preview 요소 css 클래스명
         */
        previewClass() {
            return {
                on: this.previewSwitch,
            };
        },

        /**
         * overlay 요소 css 클래스명
         */
        overlayClass() {
            return {
                on: this.overlaySwitch,
            };
        },
    },
    methods: {
        /**
         * 이미지 라이트박스 초기화
         */
        initLightbox() {

        },

        previewOn() {
            if (this.disablePreview) {
                return;
            }
            this.previewSwitch = true;


        },
        previewOff() {
            if (this.disablePreview) {
                return;
            }
            this.previewSwitch = false;
        },


        overlayOn() {
            this.overlaySwitch = true;


        },
        overlayOff() {
            this.overlaySwitch = false;
        },

        /**
         * photo zoom pro 초기화
         */
        listenCreatedPhotoZoomPro() {
            // 이미지가 너무 큰경우 화면사이즈에 딱맞게 조정
            const root = this.$refs.zoom.$el;
            const img = root.querySelector('img.img-region');
            img.style.width = "100%";
            img.style.height = "100%";
            img.style.objectFit = "contain";
        },
    },
}
</script>

<style lang="scss" scoped>
    .container {
        //border: 1px solid #fafafa;
        display: inline-block;

    }

    img.thumbnail {
        object-fit: contain;
        width: 100%;
        height: 100%;
        //cursor: zoom-in;
    }


    .preview {
        display: none; // ON시킬때, flex로 변경해야됨

        position: fixed;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);

        width: auto;
        height: 100vh;
        //background-color: rgba(0, 0, 0, 0.9);
        z-index: 999;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &.on {
            display: flex;
        }

        img {
            border: 1px solid #000;
        }
    }
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.9);
        z-index: 1000;
        display: none; // ON시킬때, flex로 변경해야됨
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .dialog-caption {
            position: absolute;
            z-index: 1001;
            top: 0;
            left: 0;
            color: #fff;
            font-size: 1.5rem;
            padding: 1.5rem;
        }

        .dialog {
            color: #fff;
            max-width: 100%;
            max-height: 100%;

        }


        &.on {
            display: flex;
        }
    }
</style>